// extracted by mini-css-extract-plugin
export default {"container":"Submission_container__eEC3c","buttonssection":"Submission_buttonssection__ITWMY","progress":"Submission_progress__4S+sF"};